module.exports = __webpack_public_path__ + "static/media/IND.9e3ac5cb.svg";